import { storageManager } from '../../../core/storage/index.js';
import { buildResumeConfig } from './hangout-config-builder.js';
import { getLastRoundSpriteTuple } from './state-utils.js';

const HANGOUT_URL = './hangout.html';

const findCharacterInState = (rankingsState, characterId) => {
  if (!rankingsState?.characters || characterId == null || characterId === '') return null;
  return rankingsState.characters.find((entry) => String(entry?.id) === String(characterId)) || null;
};

export const resumeHangoutFromConversation = async ({
  conversation,
  service,
  rankingsState
}) => {
  if (!conversation?.conversationId) return;

  const characterId = conversation.characterId;
  let character = findCharacterInState(rankingsState, characterId);
  if (!character && characterId && service?.getCharacterDetails) {
    try {
      character = await service.getCharacterDetails(characterId);
    } catch (error) {
      console.warn('resumeHangoutFromConversation: character details', error);
    }
  }

  let selectedScenario = null;
  let scenarioTime = null;
  const scenarioId = conversation.scenarioId;
  if (scenarioId && service?.getScenarioDetails) {
    try {
      selectedScenario = await service.getScenarioDetails(scenarioId);
      scenarioTime = selectedScenario?.time ?? null;
    } catch (error) {
      console.warn('resumeHangoutFromConversation: scenario details', error);
    }
  }

  const spriteTuple = getLastRoundSpriteTuple(conversation, characterId);
  const selectedOutfitId = spriteTuple.outfitId
    || conversation.allCharacters?.find((entry) => String(entry?.id) === String(characterId))?.outfitId
    || 0;

  const hangoutConfig = buildResumeConfig({
    conversation,
    character,
    carouselCharacters: [],
    selectedOutfitId,
    normalizedMessages: [],
    scenarioTime,
    selectedScenario
  });
  await storageManager.setItem('currentHangoutConfig', hangoutConfig);
  window.location.href = HANGOUT_URL;
};
